<template>
  <BaseVeeForm :action="submitForm" @success="onSuccess">
    <!-- formProps
      isIdle, isPending, isResolved, isRejected, invalid
      errors, submit
    -->
    <template #default="formProps">
      <BaseCard>
        <BaseCardBody>
          <h3 class="text-lg leading-6 font-medium text-gray-900">General Settings</h3>
        </BaseCardBody>
        <BaseCardBody>
          <BaseFormTextFieldWithValidator
            v-model="formData.name"
            :disabled="formProps.isPending"
            :validator="{
              name: 'name',
              vid: 'name',
              rules: { required: true },
            }"
            :field="{
              id: 'contact_list_name',
              label: 'Name',
            }"
            class="max-w-lg"
          />
        </BaseCardBody>
        <BaseCardFooter gray>
          <BaseButton primary> Save </BaseButton>
        </BaseCardFooter>
      </BaseCard>
    </template>
  </BaseVeeForm>
</template>

<script>
import { contactListsClient } from '@/api/clients';

export default {
  props: {
    contactList: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        name: this.contactList.name,
      },
    };
  },
  methods: {
    submitForm() {
      return contactListsClient.update(this.contactList.id, this.formData);
    },
    onSuccess() {
      this.$router.replace({
        path: this.$route.path,
        query: {
          updated: new Date().getTime(),
        },
      });
    },
  },
};
</script>
